<mat-icon
    svgIcon="auto-populate"
    muloSvgViewbox
    [ngClass]="color ? 'exl-' + color : undefined"
    [style.color]="hexColor ? hexColor : undefined"
    [matTooltip]="tooltip()"
>
</mat-icon>
